//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import { ProductFeedHealthStatusType } from '@legacy-components/catalog/product-feed-health/product-feed-health-constants';

(function() {
  angular.module('curalate').filter('formatFeedHealthStatusWithFailures', [function() {
    return function(status) {
      switch (status) {
        case ProductFeedHealthStatusType.PENDING: return 'Currently Processing';
        case ProductFeedHealthStatusType.HEALTHY: return 'Successful';
        case ProductFeedHealthStatusType.NEEDS_ATTENTION: return 'Needs Attention';
        case ProductFeedHealthStatusType.FAILURE_BAD_ACQUIRE: return 'Failure - Could not download';
        case ProductFeedHealthStatusType.FAILURE_BAD_FORMATTING: return 'Failure - Bad file formatting';
        case ProductFeedHealthStatusType.FAILURE_LARGE_LOSS: return 'Failure - Large item loss';
        case ProductFeedHealthStatusType.FAILURE_STALE_CATALOG: return 'Failure - Catalog is stale';
        case 'N/A': return 'N/A';
        default: return undefined;
      }
    };
  }]);

  angular.module('curalate').filter('formatFeedHealthConnectionStatus', [function() {
    return function(status) {
      switch (status) {
        case ProductFeedHealthStatusType.NOT_ACQUIRED: return 'Download Incomplete';
        case ProductFeedHealthStatusType.PENDING: return 'Currently Processing';
        case ProductFeedHealthStatusType.HEALTHY: return 'Healthy';
        case ProductFeedHealthStatusType.NEEDS_ATTENTION: return 'Needs Attention';
        case ProductFeedHealthStatusType.FAILURE_BAD_ACQUIRE:
        case ProductFeedHealthStatusType.FAILURE_BAD_FORMATTING:
        case ProductFeedHealthStatusType.FAILURE_LARGE_LOSS:
        case ProductFeedHealthStatusType.FAILURE_STALE_CATALOG: return 'Contact Support';
        default: return undefined;
      }
    };
  }]);

  angular.module('curalate').filter('formatCatalogItemCount', [function() {
    return function(count) {
      switch (count) {
        case '0': return '0';
        case undefined: return 'N/A';
        case null: return 'N/A';
        default: return count.toLocaleString();
      }
    };
  }]);
})();
